export const typeDocument = {
  NFS_COMISSAO_RC: {
    typeId: 1,
    resource: 'commission',
  },
};

export default {typeDocument};
